import React from 'react';
import { Button, Badge, AnimatedCounter } from '../common';
import { crms } from '../../data/process';

const styles = {
  hero: {
    position: 'relative',
    zIndex: 1,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '120px 24px 80px',
    maxWidth: '1200px',
    margin: '0 auto',
    gap: '60px',
  },
  content: {
    flex: 1,
    maxWidth: '600px',
  },
  title: {
    fontSize: 'clamp(36px, 5vw, 56px)',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    lineHeight: '1.1',
    color: '#fff',
    marginBottom: '24px',
  },
  gradient: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #06b6d4 100%)',
    backgroundSize: '200% 200%',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradient 5s ease infinite',
  },
  subtitle: {
    fontSize: '18px',
    color: '#94a3b8',
    lineHeight: '1.7',
    marginBottom: '32px',
  },
  buttons: {
    display: 'flex',
    gap: '16px',
    marginBottom: '40px',
    flexWrap: 'wrap',
  },
  crms: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  visual: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dataCard: {
    backgroundColor: 'rgba(15, 23, 42, 0.8)',
    backdropFilter: 'blur(20px)',
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '0',
    width: '320px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
    animation: 'float 6s ease-in-out infinite',
  },
  cardHeader: {
    display: 'flex',
    gap: '8px',
    padding: '16px 20px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
  },
  dot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
  },
  cardContent: {
    padding: '24px',
  },
  dataRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  dataLabel: {
    fontSize: '14px',
    color: '#94a3b8',
  },
  dataValue: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#fff',
    fontFamily: "'Space Grotesk', sans-serif",
  },
  dataBar: {
    height: '8px',
    backgroundColor: 'rgba(59, 130, 246, 0.2)',
    borderRadius: '4px',
    marginBottom: '20px',
    overflow: 'hidden',
  },
  dataBarFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #3b82f6, #8b5cf6)',
    borderRadius: '4px',
    transition: 'width 1s ease',
    width: '94%',
  },
};

export const Hero = () => {
  return (
    <section style={styles.hero}>
      <div style={styles.content}>
        <Badge showDot style={{ marginBottom: '24px' }}>
          CRM Data Specialist
        </Badge>
        <h1 style={styles.title}>
          Betrouwbare data.<br />
          <span style={styles.gradient}>Rust in sales.</span><br />
          Grip voor management.
        </h1>
        <p style={styles.subtitle}>
          Wij zorgen dat jouw CRM schoon, actueel en betrouwbaar blijft —
          zonder dat jouw team er tijd aan kwijt is.
        </p>
        <div style={styles.buttons}>
          <Button href="#contact" showArrow>
            Plan een intake
          </Button>
          <Button href="#diensten" variant="secondary">
            Bekijk diensten
          </Button>
        </div>
        <div style={styles.crms}>
          {crms.map((crm, i) => (
            <Badge key={i} variant="muted">{crm}</Badge>
          ))}
        </div>
      </div>
      <div style={styles.visual} className="hero-visual">
        <div style={styles.dataCard} className="card-premium">
          <div style={styles.cardHeader}>
            <span style={{ ...styles.dot, backgroundColor: '#ef4444' }} />
            <span style={{ ...styles.dot, backgroundColor: '#fbbf24' }} />
            <span style={{ ...styles.dot, backgroundColor: '#34d399' }} />
          </div>
          <div style={styles.cardContent}>
            <div style={styles.dataRow}>
              <span style={styles.dataLabel}>Datakwaliteit</span>
              <span style={styles.dataValue}>
                <AnimatedCounter from={0} to={94} duration={2000} suffix="%" />
              </span>
            </div>
            <div style={styles.dataBar}>
              <div style={styles.dataBarFill} />
            </div>
            <div style={styles.dataRow}>
              <span style={styles.dataLabel}>Duplicaten verwijderd</span>
              <span style={{ ...styles.dataValue, color: '#34d399' }}>
                ↓ <AnimatedCounter from={0} to={847} duration={1800} />
              </span>
            </div>
            <div style={styles.dataRow}>
              <span style={styles.dataLabel}>Schone records</span>
              <span style={styles.dataValue}>
                <AnimatedCounter from={0} to={12453} duration={2200} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
